module.exports = __webpack_public_path__ + "static/media/promo_1_mob.bc519f41.svg";